import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Button from '@mui/material/Button';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { alpha, styled } from '@mui/material/styles';
import * as React from 'react';
import { useEffect } from 'react';
import { DataTypeEnum } from '../../../_common/enum/dataType.enum';
import { IDropdownData } from '../../../_common/interface/dropdown/iDropdownData.interface';
import { dropdownService } from '../../../_services/dropdown.service';

const StyledMenu = styled((props: MenuProps) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color: 'rgb(55, 65, 81)',
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
                ...theme.applyStyles('dark', {
                    color: 'inherit',
                }),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
        ...theme.applyStyles('dark', {
            color: theme.palette.grey[300],
        }),
    },
}));

export default function AuctionUsersDropdown(params: {
    catalogueId?: number,
    catalogueUser: IDropdownData | null, setAuctionUser: React.Dispatch<IDropdownData | null>,
    onChange(catalogueUserId: number | null): void,
    style?: React.CSSProperties
}) {

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const [items, setItems] = React.useState<Array<IDropdownData>>([]);


    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event?.currentTarget);
    };

    const handleClose = (item: IDropdownData | null) => {
        setAnchorEl(null);
        params.setAuctionUser(item);
    };

    useEffect(() => {
        params.onChange(params.catalogueUser?.id ?? null);
    }, [params.catalogueUser])

    useEffect(() => {
        if (!!params.catalogueId)
            dropdownService.fetchData(DataTypeEnum.CatalogueUsers, params.catalogueId)
                .then((d) => {
                    setItems(d);

                    // Preserve the selection across a catalogue change: the same
                    // person has a different CatalogueUser id per catalogue, so
                    // re-map by underlying user identity. Clear only if they are
                    // not registered on the newly loaded catalogue.
                    const current = params.catalogueUser as any;
                    const currentUserId = current?.userId;
                    if (current && currentUserId) {
                        const list = Array.isArray(d) ? d : [];
                        const match = list.find((it: any) => String(it?.userId ?? '') === String(currentUserId));
                        if (match) {
                            if ((match as any).id !== current.id) params.setAuctionUser(match);
                        } else {
                            params.setAuctionUser(null);
                        }
                    }
                })
    }, [params.catalogueId]);

    return (
        <>
            <Button
                id="demo-customized-button"
                aria-controls={open ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="contained"
                color="primary"
                disableElevation
                style={params.style ? params.style : {}}
                onClick={handleClick}
                endIcon={<KeyboardArrowDownIcon />}
            >
                {!params.catalogueUser ? <>Select user</> : <>{params.catalogueUser?.name}</>}
            </Button>

            <StyledMenu
                id="demo-customized-menu"
                slotProps={{
                    list: {
                        'aria-labelledby': 'demo-customized-button',
                    },
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={() => (handleClose(null))}
            >
                <>
                    {!!items && items.map(m =>
                        <MenuItem onClick={(d: any) => { handleClose(m) }} disableRipple>
                            <>{m.name}</>
                        </MenuItem>
                    )}
                </>
            </StyledMenu>
        </>
    );
}